import { MessageModel } from "../../../api/api";

export const HIDDEN_PROGRESS_ATTRIBUTE = "RuntimeChatProgressHidden";
export function isHiddenProgress(message: MessageModel): boolean {
  return message.contents?.some((content) => content.attributes?.[HIDDEN_PROGRESS_ATTRIBUTE] === "true") ?? false;
}
export function isAgentProgress(message: MessageModel): boolean {
  return (
    isHiddenProgress(message) ||
    (message.contents?.some((content) =>
      Object.keys(content.attributes ?? {}).some((key) => ["progresstype", "progress:type"].includes(key.trim().toLowerCase()))
    ) ??
      false)
  );
}
